import React, { Fragment } from 'react';
export function BeforeAfterTable() {
  const rows = [{
    bad: '100+ horas/año buscando resúmenes dispersos',
    good: 'Todo organizado por materia en un solo lugar'
  }, {
    bad: 'Estudiás de cero cada parcial',
    good: '6 tomos con resúmenes listos para repasar'
  }, {
    bad: 'Finales que se acumulan sin saber por dónde empezar',
    good: 'Guía de estudio por materia + mnemotecnias'
  }, {
    bad: 'Casos clínicos que te llevan horas',
    good: 'Tomos de Guardia y Medicina Interna resueltos'
  }, {
    bad: 'Anatomía y farmacología en 5 libros distintos',
    good: 'Resúmenes filtrados en un solo material'
  }, {
    bad: 'Materias recursadas por falta de método',
    good: 'Sistema de estudio Active Recall + Anki'
  }, {
    bad: 'Sin saber qué te van a tomar en el final',
    good: 'Checklist con los 50 temas más frecuentes'
  }, {
    bad: 'Carrera desorganizada de principio a fin',
    good: 'Sistema de Gestión Académica™ desde primer año'
  }, {
    bad: 'Sin planillas editables para organizarte',
    good: '7 editables premium listos para personalizar'
  }];
  return <section className="w-full bg-white py-12 md:py-20 px-4" data-id="element-21">
      <div className="max-w-5xl mx-auto" data-id="element-22">
        <div className="text-center mb-12" data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-2" data-id="element-24">
            🩺 MÉDICO EN PROCESO™
          </h2>
          <p className="text-xl text-slate-700 font-medium mb-4 max-w-2xl mx-auto" data-id="element-25">
            El próximo parcial podés volver a improvisar. O podés entrar con
            todo resuelto desde hoy.
          </p>
          <p className="text-sm font-bold text-red-500 uppercase tracking-wider" data-id="element-26">
            ¿Cuánto cuesta NO tenerlo?
          </p>
        </div>

        <div className="rounded-2xl overflow-hidden shadow-lg border border-slate-200" data-id="element-27">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-28">
            {/* Headers */}
            <div className="bg-red-500 text-white font-bold p-4 text-center text-lg hidden md:block" data-id="element-29">
              SIN MÉDICO EN PROCESO
            </div>
            <div className="bg-green-500 text-white font-bold p-4 text-center text-lg hidden md:block" data-id="element-30">
              CON MÉDICO EN PROCESO
            </div>

            {/* Rows */}
            {rows.map((row, idx) => <Fragment key={idx} data-id="element-31">
                {/* Mobile headers (visible only on mobile) */}
                <div className="bg-red-500 text-white font-bold p-3 text-center text-sm md:hidden mt-4 first:mt-0" data-id="element-32">
                  SIN MÉDICO EN PROCESO
                </div>
                <div className={`p-4 flex items-start gap-3 ${idx % 2 === 0 ? 'bg-slate-50' : 'bg-white'} border-b border-slate-100 md:border-r`} data-id="element-33">
                  <span className="text-red-500 font-bold shrink-0 mt-0.5" data-id="element-34">
                    ✗
                  </span>
                  <span className="text-slate-700" data-id="element-35">{row.bad}</span>
                </div>

                <div className="bg-green-500 text-white font-bold p-3 text-center text-sm md:hidden" data-id="element-36">
                  CON MÉDICO EN PROCESO
                </div>
                <div className={`p-4 flex items-start gap-3 ${idx % 2 === 0 ? 'bg-slate-50' : 'bg-white'} border-b border-slate-100`} data-id="element-37">
                  <span className="text-green-500 font-bold shrink-0 mt-0.5" data-id="element-38">
                    ✓
                  </span>
                  <span className="text-slate-800 font-medium" data-id="element-39">{row.good}</span>
                </div>
              </Fragment>)}
          </div>
        </div>
      </div>
    </section>;
}